<template>
<div class="apCodeUpload-page-content winner-page__hero">
   <div class="main-block position-relative">
    <div class="position-relative">
      <div class="container-xl pt-lg-5">
        <div class="row pt-lg-5">
          <div class="col-12 col-lg-6 d-md-flex justify-content-center flex-column pt-5">
            <div class="">
              <h1 class="mt-5 mt-lg-4 text-white text-center text-lg-left text-uppercase">
                <!-- <img class="img-fluid" style="border-radius:8px;" :src="`${baseUrl}/lang_images/winner_${$store.state.currentLang}.png`" alt="winner" width="320"/> -->
                {{tr('winner-congrat')}}
              </h1>
              <p class="main-block__hero--p pt-3 text-center text-lg-left text-uppercase">{{tr('winner-ervenyes-palyazat-eseten')}}</p>
              <!--<p class="main-block__hero--p  text-center text-lg-left text-uppercase" v-if="winnerType == 'main'">{{ tr('winner-hero-sub-h1-main') }}</p>           
              <p class="main-block__hero--p  text-center text-lg-left text-uppercase" v-if="winnerType == 'main_cat'">{{ tr('winner-hero-sub-h1-weekly') }}</p>--->
              <p class="main-block__hero--p  text-center text-lg-left text-uppercase" v-if="winnerType == 'main'">{{ tr('winner-hero-sub-h1-daily') }}</p>
              <button v-if="needBtn" class="btn btn-primary mt-4 mb-4 d-none d-lg-block" v-scroll-to="{ el: '#winnerForm', offset: -80 }">{{tr('kerem-a-nyeremenyem')}}</button>
            </div>
          </div>      
          <!-- IMG - desctop     -->
          <div class="col-12 col-lg-6 align-self-center ">
            <div class="winnerType-bgr">
                <!--<img v-if="winnerType == 'daily'" :src="`${baseUrl}/lang_images/winnings/napi_${$store.state.currentLang}.png`" :alt="tr('winnings-img-alt-napi')" class="img-fluid" />
                <img v-if="winnerType == 'main_cat'" :src="`${baseUrl}/lang_images/winnings/fodij_1x_${$store.state.currentLang}.png`" :alt="tr('winnings-img-alt-heti')" class="img-fluid" />-->
                <img v-if="winnerType == 'main'" :src="`${baseUrl}/lang_images/winnings/fodij_1x_${$store.state.currentLang}.png`" :alt="tr('winnings-img-alt-main')" class="img-fluid" />             
            </div>
          </div>
          <div class="col-12 d-lg-none d-block">
            <button v-if="needBtn" class="btn btn-primary mt-4 mb-4 d-block d-lg-none" v-scroll-to="{ el: '#winnerForm', offset: -80 }">{{tr('kerem-a-nyeremenyem')}}</button>
          </div>
          </div>
        </div>   
    <div class="container-fluid py-lg-5 mt-3">
      <p class="real-info-txt py-5 text-center ml-auto mr-auto text-white">{{tr('winner-hero-info')}}</p>
    </div>
  </div>
   </div>
</div>
</template>

<script>
export default {
    props:['winnerType', 'needBtn']
}
</script>